<!-- Loading Screen -->

<div class="wrapper center"
     *ngIf="isReportSending">
  <div class="inner">
    <mat-spinner> </mat-spinner>
  </div>
</div>

<!-- Marine Mammal Interaction Report-->

<div class="container report-container">

  <div class="container"
       style="padding-top: 20px;">
    <div class="row"
         align="center">
      <h6 i18n *ngIf="currPage <= numPages">
        <small class="text-muted">
          Page {{currPage}} of {{numPages}}
        </small>
      </h6>
      <h6 i18n *ngIf="currPage > numPages">
        <small class="text-muted">
          Marine Mammal Interaction Report
        </small>
      </h6>
    </div>

    <div class="row" align="center">
      <div class="col" style="display: flex; justify-content: space-between;">
        <mat-icon></mat-icon>
        <mat-spinner *ngIf="currPage <= numPages"
                     mode="determinate"
                     [diameter]="50"
                     [strokeWidth]="6"
                     [value]="spinnerProgress"></mat-spinner>

        <mat-icon *ngIf="currPage > numPages && !isComplete"
                  style="color: #3ebfb9">
          check_circle_outline
        </mat-icon>
        <button *ngIf="!isComplete" mat-mini-fab matTooltip="Delete Report" style="background-color: #005d87;" (click)="deleteReport()">
          <mat-icon>delete</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <form [formGroup]="marineMammalInteractionForm">

    <!-- When did the interaction occur -->
    <div *ngIf="currPage === 1"
         class="container details">

      <div class="row" align="center">
        <h5 i18n class="blue-heading-title">
          Was there any accidental contact between a vehicle or fishing gear and a marine mammal?
        </h5>
        <mat-radio-group aria-label="Select an option" (change)="accidentalContactChanged($event)" formControlName="accidentalContact">
          <mat-radio-button [value]="true">Yes</mat-radio-button>
          <mat-radio-button [value]="false">No</mat-radio-button>
        </mat-radio-group>
      </div>

      <div *ngIf="!marineMammalInteractionForm.get('accidentalContact')?.value">
        <div class="row"
            align="center">
            <h5 i18n class="blue-heading-title">
                Do you have any comments to add?
            </h5>
        </div>

        <div class="row">
            <mat-form-field appearance="fill" >
                <mat-label>Remarks</mat-label>
                <textarea matInput
                maxlength="2000"
                rows="9"
                formControlName="remarks"></textarea>
            </mat-form-field>
        </div>
      </div>
      
      <div class="row" *ngIf="marineMammalInteractionForm.get('accidentalContact')?.value" align="center">
        <h5 i18n class="blue-heading-title">
          When did the interaction with a marine mammal occur?
        </h5>
      </div>

      <div class="row" *ngIf="marineMammalInteractionForm.get('accidentalContact')?.value" align="center">
        <div class="col-2"></div>
        <div class="col-8">
          <mat-card class="demo-inline-calendar-card" style="margin-top: 10%">
            <mat-calendar [(selected)]="interactionDate" [maxDate]="todayDate" (selectedChange)="dateTimeChange()"></mat-calendar>
          </mat-card>

          <div class="outer">
            <div class="inner-2">
              <h6 i18n class="blue-label">
                Time (24hr): &nbsp;
              </h6>
            </div>
            <div class="inner-2">
              <ngb-timepicker class="time-picker"
                              [spinners]="false"
                              [ngModelOptions]="{ standalone: true }"
                              [(ngModel)]="interactionTime"
                              (ngModelChange)="dateTimeChange()"></ngb-timepicker>
            </div>
            <mat-error i18n *ngIf="!interactionTime"
                       style="margin-left: 15px;">
              Required
            </mat-error>
          </div>

        </div>
        <div class="col-2"></div>
      </div>

    </div>


    <!-- Location Coordinates -->
    <div *ngIf="currPage === 2 && numPages > 1"
         class="container details">

      <div class="row"
           align="center">
        <h5 i18n class="blue-heading-title">
          Provide a description of the site where the interaction occured
        </h5>
      </div>

      <div class="row">
        <h6 i18n class="blue-label">
          Site Description
        </h6>
        <mat-form-field appearance="fill">
          <mat-label i18n>
            Site Description
          </mat-label>
          <input matInput maxlength="150" formControlName="siteDescription" required>
          <mat-error i18n *ngIf="marineMammalInteractionForm.get('siteDescription')?.invalid">
            Required
          </mat-error>
        </mat-form-field>
      </div>

      <div style="display: flex; justify-content: space-between; align-items: baseline;"> 
        <h6 i18n class="blue-label">
          What was the latitude and longitude at the interaction time?
        </h6>
        <button mat-mini-fab type="button" class="fishing-button-blue" [matTooltip]="'Fill from GPS'" (click)="geolocationMethod.fillCoordinatesFromGps(marineMammalInteractionForm.get('latitude')!, marineMammalInteractionForm.get('longitude')!)">
          <mat-icon>pin_drop</mat-icon>
        </button>  
        
      </div>

      <div class="row">          
        <mat-form-field appearance="fill">
          <mat-label i18n>Latitude</mat-label>
          <input matInput formControlName="latitude" (mousedown)="geolocationMethod.openCoordinateDialog('latitude', marineMammalInteractionForm.get('latitude')!)">
          <mat-error i18n *ngIf="marineMammalInteractionForm.get('latitude')?.hasError('object')">
            Required
          </mat-error>
          <mat-error i18n *ngIf="marineMammalInteractionForm.get('latitude')?.hasError('latitude')">
            Latitude out of range. Must be no less than 38° 00.00'N and no greater than 72° 00.00'N
          </mat-error>
        </mat-form-field>
      </div>

      <div class="row">
        <mat-form-field appearance="fill">
          <mat-label i18n>Longitude</mat-label>
          <input matInput formControlName="longitude" (mousedown)="geolocationMethod.openCoordinateDialog('longitude', marineMammalInteractionForm.get('longitude')!)">
          <mat-error i18n *ngIf="marineMammalInteractionForm.get('longitude')?.hasError('object')">
            Required
          </mat-error>
          <mat-error i18n *ngIf="marineMammalInteractionForm.get('longitude')?.hasError('longitude')">
            Longitude out of range. Must be no less than 40° 00.00'W and no greater than 148° 00.00'W
          </mat-error>
        </mat-form-field>
      </div>

    </div>

    <!-- Personal Info -->
    <div *ngIf="currPage === 3 && numPages > 1"
         class="container">

      <div class="row"
           align="center">
        <h5 i18n class="blue-heading-title">
          Personal Info
        </h5>
      </div>

      <div class="row">
        <h6 i18n class="blue-heading">
          Full name
        </h6>
        <mat-form-field appearance="outline">
          <mat-label i18n>
            Full name
          </mat-label>
          <input matInput maxlength="80" formControlName="fullName">
          <mat-error i18n *ngIf="marineMammalInteractionForm.get('fullName')?.errors?.required">
            Required
          </mat-error>
        </mat-form-field>
      </div>

      <div class="row">
        <h6 i18n class="blue-heading">
          Address
        </h6>
        <mat-form-field appearance="outline">
          <mat-label i18n>
            Address
          </mat-label>
          <input matInput maxlength="200" formControlName="address"
                 [value]="userDetails.address">
          <mat-error i18n *ngIf="marineMammalInteractionForm.invalid">
            Required
          </mat-error>
        </mat-form-field>
      </div>

      <div class="row">
        <h6 i18n class="blue-heading">
          Province
        </h6>
        <mat-form-field appearance="outline">
          <mat-label i18n>
            Province
          </mat-label>
          <mat-select formControlName="province">
            <mat-option i18n *ngFor="let province of provinceOptions"
                        [value]="province">
              {{province}}
            </mat-option>
          </mat-select>
          <mat-error i18n *ngIf="marineMammalInteractionForm.invalid">
            Required
          </mat-error>
        </mat-form-field>
      </div>

      <div class="row">
        <h6 i18n class="blue-heading">
          Phone number
        </h6>
        <mat-form-field appearance="outline">
          <mat-label i18n>
            Phone number
          </mat-label>
          <input matInput maxlength="25" formControlName="phoneNum">
          <mat-error i18n *ngIf="marineMammalInteractionForm.invalid">
            Required
          </mat-error>
        </mat-form-field>
      </div>

      <div class="row">
        <h6 i18n class="blue-heading">
          Email
        </h6>
        <mat-form-field appearance="outline">
          <mat-label i18n>
            Email
          </mat-label>
          <input matInput maxlength="50" formControlName="email">
          <mat-error i18n *ngIf="marineMammalInteractionForm.invalid">
            Required
          </mat-error>
        </mat-form-field>
      </div>

      <!-- Vessel Info -->
      <div class="row"
           align="center">
        <h5 i18n class="blue-heading-title">
          Vessel Info
        </h5>
      </div>

      <div class="row">
        <h6 i18n class="blue-heading">
          Vessel name
        </h6>
        <mat-form-field appearance="outline">
          <mat-label i18n>
            Vessel name
          </mat-label>
          <mat-select formControlName="vesselName" [compareWith]="compareVessel">
            <mat-option i18n *ngFor="let vessel of userDetails.vessels"
                        [value]="vessel">
              {{vessel}}
            </mat-option>
          </mat-select>
          <mat-error i18n *ngIf="marineMammalInteractionForm.invalid">
            Required
          </mat-error>
        </mat-form-field>
      </div>

      <div class="row">
        <h6 i18n class="blue-heading">
          Targeted species
        </h6>
        <mat-form-field appearance="outline">
          <mat-label i18n>
            Select
          </mat-label>
          <mat-select formControlName="targetedSpecies">
            <mat-option i18n *ngFor="let species of targetedSpeciesOptions"
                        [value]="species">
              {species, select, Salmon, Chinook {Salmon, Chinook} Salmon, Chum {Salmon, Chum} Salmon, Coho {Salmon, Coho} Salmon, Pink {Salmon, Pink} Salmon, Sockeye {Salmon, Sockeye}}
            </mat-option>
          </mat-select>
          <mat-error i18n *ngIf="marineMammalInteractionForm.invalid">
            Required
          </mat-error>
        </mat-form-field>
      </div>

      <div class="row">
        <h6 i18n class="blue-heading">
          Fishing gear
        </h6>
        <mat-form-field appearance="outline">
          <mat-label i18n>
            Select
          </mat-label>
          <mat-select formControlName="fishingGear">
            <mat-option i18n *ngFor="let gear of gearOptions"
                        [value]="gear">
              {gear, select, Gillnet {Gillnet} Gillnet (drift) {Gillnet (drift)} Seines nets (not specified) {Seines nets (not specified)} Troller lines {Troller lines}}
            </mat-option>
          </mat-select>
          <mat-error i18n *ngIf="marineMammalInteractionForm.invalid">
            Required
          </mat-error>
        </mat-form-field>
      </div>

      <div class="row"
           align="center">
        <h5 i18n class="blue-heading-title">
          Is fishing gear damaged? &nbsp;&nbsp;
          <mat-label ngClass="labelBeforeSlide">No  </mat-label>
          <mat-slide-toggle formControlName="gearDamaged">Yes</mat-slide-toggle>
        </h5>
      </div>

      <div class="row"
           align="center">
        <h5 i18n class="blue-heading-title">
          Is fishing gear fully or partially lost? &nbsp;&nbsp;
          <mat-label ngClass="labelBeforeSlide">No  </mat-label>
          <mat-slide-toggle formControlName="gearLost">Yes</mat-slide-toggle>
        </h5>
      </div>

      <div class="row"
           align="center">
        <h5 i18n class="blue-heading-title">
          Is the cause of the gear loss known? &nbsp;&nbsp;
          <mat-label ngClass="labelBeforeSlide">No  </mat-label>
          <mat-slide-toggle formControlName="causeKnown">Yes</mat-slide-toggle>
        </h5>
      </div>

      <div class="row" *ngIf="marineMammalInteractionForm.get('causeKnown')?.value == true">
        <h6 i18n class="blue-heading">
          Remark (lost gear)
        </h6>
        <mat-form-field appearance="outline">
          <mat-label i18n>
            Remark
          </mat-label>
          <input matInput maxlength="150" formControlName="lostGearRemark">
          <mat-error i18n *ngIf="marineMammalInteractionForm.invalid">
            Required
          </mat-error>
        </mat-form-field>
      </div>

    </div>

    <!-- Species Info -->
    <div *ngIf="currPage === 4 && numPages > 1"
         class="container">

      <div class="row"
           align="center">
        <h5 i18n class="blue-heading-title">
          Species Info
        </h5>
      </div>

      <div class="row">
        <h6 i18n class="blue-heading">
          Species
        </h6>
        <mat-form-field appearance="fill">
          <mat-label i18n>
            Species
          </mat-label>
          <input matInput
                 required
                 formControlName="species"
                 [matAutocomplete]="auto">
          <mat-autocomplete #auto="matAutocomplete">
            <mat-option *ngFor="let fSpecies of filteredSpecies"
                        [value]="fSpecies">
              {{fSpecies}}
            </mat-option>
          </mat-autocomplete>
          <mat-error i18n *ngIf="marineMammalInteractionForm.invalid">
            Required
          </mat-error>
        </mat-form-field>
      </div>

      <div class="row">
        <h6 i18n class="blue-heading">
          Description of marine mammal(s)
        </h6>
        <mat-form-field appearance="outline">
          <mat-label i18n>
            Description of marine mammal(s)
          </mat-label>
          <input matInput maxlength="150" formControlName="speciesDescription">
          <mat-error i18n *ngIf="marineMammalInteractionForm.invalid">
            Required
          </mat-error>
        </mat-form-field>
      </div>


      <div class="row">
        <h6 i18n class="blue-heading">
          Animal condition
        </h6>
        <mat-form-field appearance="outline">
          <mat-label i18n>
            Select
          </mat-label>
          <mat-select formControlName="condition">
            <mat-option i18n *ngFor="let condition of conditionOptions"
                        [value]="condition">
              {condition, select, Appears Healthy {Appears Healthy} Dead {Dead} Sick {Sick} Injured {Injured} Unknown {Unknown}}
            </mat-option>
          </mat-select>
          <mat-error i18n *ngIf="marineMammalInteractionForm.invalid">
            Required
          </mat-error>
        </mat-form-field>
      </div>

      <div class="row">
        <h6 i18n class="blue-heading">
          Identification confidence
        </h6>
        <mat-form-field appearance="outline">
          <mat-label i18n>
            Select
          </mat-label>
          <mat-select formControlName="identificationConfidence">
            <mat-option i18n *ngFor="let confidence of confidenceOptions"
                        [value]="confidence">
              {confidence, select, Certain {Certain} Probable {Probable} Possible {Possible} Uncertain {Uncertain}}
            </mat-option>
          </mat-select>
          <mat-error i18n *ngIf="marineMammalInteractionForm.invalid">
            Required
          </mat-error>
        </mat-form-field>
      </div>

      <div class="row">
        <h6 i18n class="blue-heading">
          Minimum number of specimens involved
        </h6>
        <mat-form-field appearance="outline">
          <mat-label i18n>
            Minimum
          </mat-label>
          <input matInput
                 type="number"
                 inputmode="numeric"
                 formControlName="minSpecimens">
          <mat-error i18n *ngIf="marineMammalInteractionForm.get('minSpecimens')?.errors?.required">
            Required
          </mat-error>
          <mat-error i18n *ngIf="marineMammalInteractionForm.get('minSpecimens')?.hasError('minMaxError') || marineMammalInteractionForm.get('maxSpecimens')?.hasError('minMaxError')">
            Minimum must be less than or equal to Maximum
          </mat-error>
        </mat-form-field>
      </div>

      <div class="row">
        <h6 i18n class="blue-heading">
          Maximum number of specimens involved
        </h6>
        <mat-form-field appearance="outline">
          <mat-label i18n>
            Maximum
          </mat-label>
          <input matInput
                 type="number"
                 inputmode="numeric"
                 formControlName="maxSpecimens">
          <mat-error i18n *ngIf="marineMammalInteractionForm.get('maxSpecimens')?.errors?.required">
            Required
          </mat-error>
          <mat-error i18n *ngIf="marineMammalInteractionForm.get('minSpecimens')?.hasError('minMaxError') || marineMammalInteractionForm.get('maxSpecimens')?.hasError('minMaxError')">
            Maximum must be greater than or equal to Minimum
          </mat-error>
        </mat-form-field>
      </div>

      <div class="row">
        <h6 i18n class="blue-heading">
          Best estimate of the number of specimens
        </h6>
        <mat-form-field appearance="outline">
          <mat-label i18n>
            Maximum
          </mat-label>
          <input matInput
                 type="number"
                 inputmode="numeric"
                 formControlName="bestEstimateSpecimens">
          <mat-error i18n *ngIf="marineMammalInteractionForm.get('bestEstimateSpecimens')?.errors?.required">
            Required
          </mat-error>
          <mat-error i18n *ngIf="marineMammalInteractionForm.get('bestEstimateSpecimens')?.hasError('bestEstimateError')">
            The best estimate must be between the minimum and maximum estimates.
          </mat-error>
        </mat-form-field>
      </div>

      <div class="row"
           align="center">
        <h5 i18n class="blue-heading-title">
          Have one or more videos been recorded? &nbsp;&nbsp;
          <mat-label ngClass="labelBeforeSlide">No  </mat-label>
          <mat-slide-toggle formControlName="videosRecorded">Yes</mat-slide-toggle>
        </h5>
      </div>

      <div class="row"
           align="center">
        <h5 i18n class="blue-heading-title">
          Have one or more photos been taken? &nbsp;&nbsp;
          <mat-label ngClass="labelBeforeSlide">No  </mat-label>
          <mat-slide-toggle formControlName="photosTaken">Yes</mat-slide-toggle>
        </h5>
      </div>

      <div class="row"
           align="center">
        <h5 i18n class="blue-heading-title">
          Have one or more samples been taken? &nbsp;&nbsp;
          <mat-label ngClass="labelBeforeSlide">No  </mat-label>
          <mat-slide-toggle formControlName="samplesTaken">Yes</mat-slide-toggle>
        </h5>
      </div>

      <div class="row"
           align="center">
        <h5 i18n class="blue-heading-title">
          Are other documents available? &nbsp;&nbsp;
          <mat-label ngClass="labelBeforeSlide">No  </mat-label>
          <mat-slide-toggle formControlName="documentsAvailable">Yes</mat-slide-toggle>
        </h5>
      </div>

      <div class="row" *ngIf="marineMammalInteractionForm.get('documentsAvailable')?.value == true">
        <h6 i18n class="blue-heading">
          If other documents are available, provide details about the available documentation
        </h6>
        <mat-form-field appearance="outline">
          <mat-label i18n>
            Remarks
          </mat-label>
          <input matInput maxlength="150" formControlName="documentRemarks">
          <mat-error i18n *ngIf="marineMammalInteractionForm.invalid">
            Required
          </mat-error>
        </mat-form-field>
      </div>

      <div class="row">
        <h6 i18n class="blue-heading">
          Body length category
        </h6>
        <mat-form-field appearance="outline">
          <mat-label i18n>
            Select
          </mat-label>
          <mat-select formControlName="bodyLengthCategory">
            <mat-option i18n *ngFor="let length of bodyLengthOptions" [value]="length">
              <div *ngIf="length == 'Other'">
                {length, select, Other {Other}}
              </div>
              <div *ngIf="length != 'Other'">
                {{length}}
              </div>
            </mat-option>
          </mat-select>
          <mat-error i18n *ngIf="marineMammalInteractionForm.invalid">
            Required
          </mat-error>
        </mat-form-field>
      </div>

      <div class="row" *ngIf="marineMammalInteractionForm.get('bodyLengthCategory')?.value === 'Other'">
        <h6 i18n class="blue-heading">
          Body length
        </h6>
        <mat-form-field appearance="outline">
          <mat-label i18n>
            Length
          </mat-label>
          <input matInput
                 formControlName="bodyLength">
          <mat-error i18n *ngIf="marineMammalInteractionForm.invalid">
            Required
          </mat-error>
        </mat-form-field>
      </div>

      <div class="row">
        <h6 i18n class="blue-heading">
          Provide a description of the event (event, timeline, actions, people involved, etc.)
        </h6>
        <mat-form-field appearance="outline">
          <mat-label i18n>
            Event description
          </mat-label>
          <input matInput maxlength="150" formControlName="eventDescription">
          <mat-error i18n *ngIf="marineMammalInteractionForm.invalid">
            Required
          </mat-error>
        </mat-form-field>
      </div>
    </div>

    <!-- Incident List -->
    <div *ngIf="currPage === 5 && numPages > 1">

      <div class="row"
           align="center">
        <h5 i18n class="blue-heading-title">
          Incident(s) Details
        </h5>
      </div>

      <ng-container formArrayName="incidents">
        <ng-container *ngFor="let incidentForm of incidentControls; let i = index">

          <form [formGroup]="incidentForm">

            <div class="row" align="center">
              <h6 i18n class="blue-heading">
                Incident type
              </h6>
              <div style="display: flex;">
                <mat-form-field appearance="outline" style="flex-grow: 1;">
                  <mat-label i18n>
                    Select
                  </mat-label>
                  <mat-select formControlName="type">
                    <mat-option i18n *ngFor="let incident of incidentTypeOptions"
                                [value]="incident">
                      {incident, select, Collision {Collision} Dead animal {Dead animal} Depredation {Depredation} Entanglement {Entanglement} Harassment {Harassment} Live stranding {Live stranding} Shooting {Shooting} Sick or injured {Sick or injured}}
                    </mat-option>
                  </mat-select>
                  <mat-error i18n *ngIf="incidentForm.invalid">
                    Required
                  </mat-error>
                </mat-form-field>

                <button mat-mini-fab *ngIf="i != 0" (click)="deleteIncident(i)" style="background-color: #005d87; margin-left: 10px;">
                  <mat-icon>
                    delete_forever
                  </mat-icon>
                </button>

              </div>

            </div>

            <div class="row" align="center">
              <h6 i18n style="color:#005d87">
                Remark (Incident type)
              </h6>
              <mat-form-field appearance="outline">
                <mat-label i18n>
                  Remark
                </mat-label>
                <input matInput
                       formControlName="description">
                <mat-error i18n *ngIf="incidentForm.invalid">
                  Required
                </mat-error>
              </mat-form-field>
            </div>

          </form>


        </ng-container>

        <div class="row" align="center">
          <button i18n mat-raised-button style="background-color: coral; color: white; font-weight: bold; width: auto; margin-bottom: 25px;" (click)="addIncident()">
            Add an incident
          </button>

        </div>

      </ng-container>

    </div>

    <!-- Remarks -->
    <div *ngIf="currPage === numPages && numPages > 1" class="container details">

      <div class="row"
          align="center">
          <h5 i18n class="blue-heading-title">
              Do you have any comments to add?
          </h5>
      </div>

      <div class="row">
          <mat-form-field appearance="fill" >
              <mat-label>Comments</mat-label>
              <textarea matInput
              maxlength="2000"
              rows="9"
              formControlName="remarks"></textarea>
          </mat-form-field>
      </div>

    </div>

    <!-- Summary page -->

    <div *ngIf="currPage > numPages"
         class="container details">
      <div class="row" *ngIf="!isComplete"
           align="center">
        <h5 i18n class="blue-heading-title">
          Is all information complete and ready to be saved?
        </h5>
      </div>


      <div class="row">
        <h6 i18n class="blue-label">
          <b>Accidental contact:</b>
          <span *ngIf="marineMammalInteractionForm.get('accidentalContact')?.value; else elseBlock">
            Yes
          </span>
          <ng-template #elseBlock> No</ng-template>
        </h6>
      </div>

      <div *ngIf="marineMammalInteractionForm.get('accidentalContact')?.value">

        <div class="row">
          <h6 i18n class="blue-label">
            <b>
              Interaction Date:
            </b>
            {{ interactionDate | date }}
          </h6>
        </div>

        <div class="row">
          <h6 i18n class="blue-label">
            <b>
              Interaction Time:
            </b>
            <span *ngIf="interactionTimeValid">
              {{ getInteractionTime() | date:'h:mm a' }}
            </span>
            <span *ngIf="!interactionTimeValid"
                  class="invalid-field">
              [Required]
            </span>
          </h6>
        </div>

        <div class="row">
          <h6 i18n class="blue-label">
            <b>Site description:</b>
            <span>
              {{marineMammalInteractionForm.get('siteDescription')?.value}}
            </span>
            <small *ngIf="marineMammalInteractionForm.get('siteDescription')?.errors?.required"
                   class="red-label">
              [Required]
            </small>
          </h6>
        </div>

        <div class="row">
          <h6 i18n class="blue-label">
            <b>Latitude:</b>
            <span>
              {{marineMammalInteractionForm.get('latitude')?.value}}
            </span>
            <small *ngIf="marineMammalInteractionForm.get('latitude')?.errors?.object"
                   class="red-label">
              [Required]
            </small>
          </h6>
        </div>

        <div class="row">
          <h6 i18n class="blue-label">
            <b>Longitude:</b>
            <span>
              {{marineMammalInteractionForm.get('longitude')?.value}}
            </span>
            <small *ngIf="marineMammalInteractionForm.get('longitude')?.errors?.object"
                   class="red-label">
              [Required]
            </small>
          </h6>
        </div>

        <div class="row">
          <h6 i18n class="blue-label">
            <b>Full name:</b>
            <span>
              {{marineMammalInteractionForm.get('fullName')?.value}}
            </span>
            <small *ngIf="marineMammalInteractionForm.get('fullName')?.errors?.required"
                   class="red-label">
              [Required]
            </small>
          </h6>
        </div>

        <div class="row">
          <h6 i18n class="blue-label">
            <b>Address:</b>
            <span>
              {{marineMammalInteractionForm.get('address')?.value}}
            </span>
            <small *ngIf="marineMammalInteractionForm.get('address')?.errors?.required"
                   class="red-label">
              [Required]
            </small>
          </h6>
        </div>

        <div class="row">
          <h6 i18n class="blue-label">
            <b>Province:</b>
            <span>
              {{marineMammalInteractionForm.get('province')?.value}}
            </span>
            <small *ngIf="marineMammalInteractionForm.get('province')?.errors?.required"
                   class="red-label">
              [Required]
            </small>
          </h6>
        </div>

        <div class="row">
          <h6 i18n class="blue-label">
            <b>Phone number:</b>
            <span>
              {{marineMammalInteractionForm.get('phoneNum')?.value}}
            </span>
            <small *ngIf="marineMammalInteractionForm.get('phoneNum')?.errors?.required"
                   class="red-label">
              [Required]
            </small>
          </h6>
        </div>

        <div class="row">
          <h6 i18n class="blue-label">
            <b>Email:</b>
            <span>
              {{marineMammalInteractionForm.get('email')?.value}}
            </span>
            <small *ngIf="marineMammalInteractionForm.get('email')?.errors?.required"
                   class="red-label">
              [Required]
            </small>
          </h6>
        </div>

        <div class="row">
          <h6 i18n class="blue-label">
            <b>Vessel name:</b>
            <span>
              {{marineMammalInteractionForm.get('vesselName')?.value}}
            </span>
            <small *ngIf="marineMammalInteractionForm.get('vesselName')?.errors?.required"
                   class="red-label">
              [Required]
            </small>
          </h6>
        </div>

        <div class="row">
          <h6 i18n class="blue-label">
            <b>Targeted species:</b>
            <span>
              {{marineMammalInteractionForm.get('targetedSpecies')?.value}}
            </span>
            <small *ngIf="marineMammalInteractionForm.get('targetedSpecies')?.errors?.required"
                   class="red-label">
              [Required]
            </small>
          </h6>
        </div>

        <div class="row">
          <h6 i18n class="blue-label">
            <b>Fishing gear:</b>
            <span>
              {{marineMammalInteractionForm.get('fishingGear')?.value}}
            </span>
            <small *ngIf="marineMammalInteractionForm.get('fishingGear')?.errors?.required"
                   class="red-label">
              [Required]
            </small>
          </h6>
        </div>

        <div class="row">
          <h6 i18n class="blue-label">
            <b>Fishing gear damaged?</b>
            <span *ngIf="marineMammalInteractionForm.get('gearDamaged')?.value; else elseBlock">
              Yes
            </span>
            <ng-template #elseBlock> No</ng-template>
          </h6>
        </div>

        <div class="row">
          <h6 i18n class="blue-label">
            <b>Fishing gear lost?</b>
            <span *ngIf="marineMammalInteractionForm.get('gearLost')?.value; else elseBlock">
              Yes
            </span>
            <ng-template #elseBlock> No</ng-template>
          </h6>
        </div>

        <div class="row">
          <h6 i18n class="blue-label">
            <b>Cause of gear loss known?</b>
            <span *ngIf="marineMammalInteractionForm.get('causeKnown')?.value; else elseBlock">
              Yes
            </span>
            <ng-template #elseBlock> No</ng-template>
          </h6>
        </div>

        <div class="row" *ngIf="marineMammalInteractionForm.get('causeKnown')?.value">
          <h6 i18n class="blue-label">
            <b>Remark (lost gear):</b>
            <span>
              {{marineMammalInteractionForm.get('lostGearRemark')?.value}}
            </span>
            <small *ngIf="marineMammalInteractionForm.get('lostGearRemark')?.errors?.required"
                   class="red-label">
              [Required]
            </small>
          </h6>
        </div>

        <div class="row">
          <h6 i18n class="blue-label">
            <b>Species:</b>
            <span>
              {{marineMammalInteractionForm.get('species')?.value}}
            </span>
            <small *ngIf="marineMammalInteractionForm.get('species')?.errors?.required"
                   class="red-label">
              [Required]
            </small>
          </h6>
        </div>

        <div class="row">
          <h6 i18n class="blue-label">
            <b>Description:</b>
            <span>
              {{marineMammalInteractionForm.get('speciesDescription')?.value}}
            </span>
            <small *ngIf="marineMammalInteractionForm.get('speciesDescription')?.errors?.required"
                   class="red-label">
              [Required]
            </small>
          </h6>
        </div>

        <div class="row">
          <h6 i18n class="blue-label">
            <b>Animal condition:</b>
            <span>
              {{marineMammalInteractionForm.get('condition')?.value}}
            </span>
            <small *ngIf="marineMammalInteractionForm.get('condition')?.errors?.required"
                   class="red-label">
              [Required]
            </small>
          </h6>
        </div>

        <div class="row">
          <h6 i18n class="blue-label">
            <b>Identification confidence:</b>
            <span>
              {{marineMammalInteractionForm.get('identificationConfidence')?.value}}
            </span>
            <small *ngIf="marineMammalInteractionForm.get('identificationConfidence')?.errors?.required"
                   class="red-label">
              [Required]
            </small>
          </h6>
        </div>

        <div class="row">
          <h6 i18n class="blue-label">
            <b>Minimum number of specimens involved:</b>
            <span>
              {{ marineMammalInteractionForm.get('minSpecimens')?.value }}
            </span>
            <small *ngIf="marineMammalInteractionForm.get('minSpecimens')?.errors?.required" class="red-label">
              [Required]
            </small>
            <small *ngIf="marineMammalInteractionForm.get('minSpecimens')?.hasError('minMaxError')" class="red-label">
              [Minimum must be less than or equal to Maximum]
            </small>
          </h6>
        </div>

        <div class="row">
          <h6 i18n class="blue-label">
            <b>Maximum number of specimens involved:</b>
            <span>
              {{ marineMammalInteractionForm.get('maxSpecimens')?.value }}
            </span>
            <small *ngIf="marineMammalInteractionForm.get('maxSpecimens')?.errors?.required" class="red-label">
              [Required]
            </small>
            <small *ngIf="marineMammalInteractionForm.get('maxSpecimens')?.hasError('minMaxError')" class="red-label">
              [Maximum must be greater than or equal to Minimum]
            </small>
          </h6>
        </div>

        <div class="row">
          <h6 i18n class="blue-label">
            <b>Best estimate of the number of specimens:</b>
            <span>
              {{ marineMammalInteractionForm.get('bestEstimateSpecimens')?.value }}
            </span>
            <small *ngIf="marineMammalInteractionForm.get('bestEstimateSpecimens')?.errors?.required" class="red-label">
              [Required]
            </small>
            <small *ngIf="marineMammalInteractionForm.get('bestEstimateSpecimens')?.hasError('bestEstimateError')" class="red-label">
              [The best estimate must be between the minimum and maximum estimates.]
            </small>
          </h6>
        </div>

        <div class="row">
          <h6 i18n class="blue-label">
            <b>Videos recorded?</b>
            <span *ngIf="marineMammalInteractionForm.get('videosRecorded')?.value; else elseBlock">
              Yes
            </span>
            <ng-template #elseBlock> No</ng-template>
          </h6>
        </div>

        <div class="row">
          <h6 i18n class="blue-label">
            <b>Photos taken?</b>
            <span *ngIf="marineMammalInteractionForm.get('photosTaken')?.value; else elseBlock">
              Yes
            </span>
            <ng-template #elseBlock> No</ng-template>
          </h6>
        </div>

        <div class="row">
          <h6 i18n class="blue-label">
            <b>Samples taken?</b>
            <span *ngIf="marineMammalInteractionForm.get('samplesTaken')?.value; else elseBlock">
              Yes
            </span>
            <ng-template #elseBlock> No</ng-template>
          </h6>
        </div>

        <div class="row">
          <h6 i18n class="blue-label">
            <b>Other documents available?</b>
            <span *ngIf="marineMammalInteractionForm.get('documentsAvailable')?.value; else elseBlock">
              Yes
            </span>
            <ng-template #elseBlock> No</ng-template>
          </h6>
        </div>

        <div class="row" *ngIf="marineMammalInteractionForm.get('documentsAvailable')?.value">
          <h6 i18n class="blue-label">
            <b>Document remarks:</b>
            <span>
              {{marineMammalInteractionForm.get('documentRemarks')?.value}}
            </span>
            <small *ngIf="marineMammalInteractionForm.get('documentRemarks')?.errors?.required"
                   class="red-label">
              [Required]
            </small>
          </h6>
        </div>

        <div class="row">
          <h6 i18n class="blue-label">
            <b>Body length category:</b>
            <span>
              {{marineMammalInteractionForm.get('bodyLengthCategory')?.value}}
            </span>
            <small *ngIf="marineMammalInteractionForm.get('bodyLengthCategory')?.errors?.required"
                   class="red-label">
              [Required]
            </small>
          </h6>
        </div>

        <div class="row" *ngIf="marineMammalInteractionForm.get('bodyLengthCategory')?.value === 'Other'">
          <h6 i18n class="blue-label">
            <b>Body length:</b>
            <span>
              {{marineMammalInteractionForm.get('bodyLength')?.value}}
            </span>
            <small *ngIf="marineMammalInteractionForm.get('bodyLength')?.errors?.required"
                   class="red-label">
              [Required]
            </small>
          </h6>
        </div>

        <div class="row">
          <h6 i18n class="blue-label">
            <b>Event description:</b>
            <span>
              {{marineMammalInteractionForm.get('eventDescription')?.value}}
            </span>
            <small *ngIf="marineMammalInteractionForm.get('eventDescription')?.errors?.required"
                   class="red-label">
              [Required]
            </small>
          </h6>
        </div>

        <div class="row">
          <h6 i18n class="blue-label">
            <b>Incidents:</b>
            <small *ngIf="incidents.at(0).invalid"
                   class="red-label">
              [Required]
            </small>
          </h6>
  
          <mat-list role="list">
            <mat-list-item *ngFor="let incident of incidentControls; let i = index" role="listitem">
              <span class="blue-label">
                {{incident.controls['type'].value}} - {{incident.controls['description'].value}}
              </span>
              <small *ngIf="incident.invalid"
                     class="red-label">
                [Missing details]
              </small>
            </mat-list-item>
          </mat-list>
  
        </div>

      </div>

      <div class="row">
        <h6 i18n class="blue-label">
          <b>
            Comments:
          </b>
          {{ marineMammalInteractionForm.get('remarks')?.value }}
        </h6>
      </div>

    </div>
  </form>


  <!-- Page navigation buttons -->
  <div class="row bottom-buttons" *ngIf="!isComplete">
    <div class="col-1"></div>
    <div class="col-4">
      <div class="row">
        <button mat-raised-button
                class="fishing-button-blue"
                type="button"
                (click)="toPreviousPage()">
          <span i18n>
            Back
          </span>
        </button>
      </div>
    </div>
    <div class="col-2"></div>
    <div class="col-4">
      <div class="row">
        <button mat-raised-button
                class="fishing-button-red"
                type="submit"
                (click)="toNextPage()">
          <span i18n *ngIf="currPage <= numPages">
            Next
          </span>
          <span i18n *ngIf="currPage > numPages">
            Save
          </span>
        </button>
      </div>
    </div>
    <div class="col-1"></div>
  </div>
  <div class="row bottom-buttons" *ngIf="isComplete" style="display: flex; justify-content: center;">
    <div class="col-4">
      <div class="row" style="display: flex; justify-content: center;">
        <button mat-raised-button
                class="fishing-button-blue"
                type="button"
                (click)="toPreviousPage()">
          <span i18n>
            Back
          </span>
        </button>
      </div>
    </div>
  </div>
</div>
